import {formatTimeZoneDate, formatTons} from '@hconnect/uikit'
import {useUpmPlantTimezone} from '@hconnect/upm'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../../consts'

interface DeliveriesCardHeaderParams {
  amount: number
  scheduledDate: string
  documentNumber?: string
  positionNumber?: string
}

export const useDeliveriesCardHeaderOrderInfo = ({
  amount,
  scheduledDate,
  documentNumber,
  positionNumber
}: DeliveriesCardHeaderParams) => {
  const {
    t,
    i18n: {language}
  } = useTranslation(FEATURE_NAMESPACE)
  const timezoneId = useUpmPlantTimezone()
  const formatOrderDate = (date: string) => formatTimeZoneDate(date, timezoneId, 'L', language)
  return [
    formatTons(amount, language),
    formatOrderDate(scheduledDate),
    ...(documentNumber
      ? [t('stock.materialOrders.agreementNumber', {number: documentNumber})]
      : []),
    ...(positionNumber ? [t('stock.materialOrders.position', {number: positionNumber})] : [])
  ].join(' | ')
}
